export { BvlDatepickerComponent as BvlDatepicker } from './datepicker.component';
export { BvlDatepickerModule } from './datepicker.module';
